import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EVENTS_QUEUE } from '../types';
import LocalStorage from './localStorage';
import EnrichmentManager from '../enrich/enrichManager';
/**
 * Utilising queue for:
 *  1. General Event Flow - For each event to get fire
 *     it has to go to queue then will be captured. This will
 *     help in the usecase when we're firing event when page
 *     loaded. Because while redirecting browser cancels
 *     all ongoing requests.
 *  2. Retries - In case of any failed event.
 *
 * Note - Queue will always be in sync with local storage.
 *  */
var EventsQueue = /*#__PURE__*/function () {
  // init queue and retrieve EVENTS_QUEUE from localStorage if it exists
  function EventsQueue() {
    _classCallCheck(this, EventsQueue);
    _defineProperty(this, "enrichmentManager", new EnrichmentManager());
  }
  _createClass(EventsQueue, [{
    key: "updateLocalStorage",
    value: function updateLocalStorage() {
      LocalStorage.setItem(EVENTS_QUEUE, EventsQueue.events);
    }

    // return all events currently present in the queue
  }, {
    key: "getEvents",
    value: function getEvents() {
      return EventsQueue.events;
    }

    // add event to queue and update localStorage
  }, {
    key: "add",
    value: function add(eventType, eventData, enrichmentManager) {
      // get raw data of enrichers before storing it to local storage
      var event = {
        eventType: eventType,
        eventData: eventData.serializeBinary(),
        enrich: enrichmentManager.getRawEnrichers()
      };
      EventsQueue.events.push(event);
      this.updateLocalStorage();
    }

    // remove first event from queue if the queue is not empty
    // and update localStorage else return undefined
  }, {
    key: "remove",
    value: function remove() {
      var firstEvent = EventsQueue.events.shift();
      this.updateLocalStorage();
      return firstEvent;
    }

    // return first event of the queue
  }, {
    key: "peek",
    value: function peek() {
      var event = EventsQueue.events[0];
      // convert raw enrichers to instance and then process it further
      this.enrichmentManager.updateEnrichersFromRaw(event.enrich);
      return {
        eventType: event.eventType,
        eventData: event.eventData,
        enrichmentManager: this.enrichmentManager
      };
    }

    // return true if queue is empty
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return EventsQueue.events.length === 0;
    }
  }]);
  return EventsQueue;
}();
_defineProperty(EventsQueue, "events", LocalStorage.getItem(EVENTS_QUEUE) || []);
export default EventsQueue;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/utils/EventsQueue.js
// module id = 1441
// module chunks = 11